import request from '../utils/request'

export function selectPopup(data) {
  return request({
    url: '/api/popup/fetch',
    method: 'post',
    data,
  })
}

